export default __webpack_public_path__ + "static/media/arrow-up.2a189ca7.svg";